exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".kawo-tooltip{max-width:200px;padding:3px 8px;font-size:13px;color:#fff;background-color:#000;border-radius:3px}.kawo-tooltip-arrow{border:6px solid #000;border-bottom-color:transparent;border-right-color:transparent}.kawo-tooltip small{font-size:12px;color:#ddd}.box{width:44px;height:44px;position:fixed;background-color:#ddd}.top-right{top:20px;right:20px}.top-right-70{top:20px;right:70px}.top-70-right{top:70px;right:20px}.top-center{top:20px;left:50%;margin-left:-22px}.top-left{top:20px;left:20px}.bottom-right{bottom:20px;right:20px}.bottom-center{bottom:20px;left:50%;margin-left:-22px}.bottom-left{bottom:20px;left:20px}.center-center{position:absolute;top:50%;left:50%;margin:-22px 0 0 -22px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/app/styles/tooltip.css
// module id = 231
// module chunks = 0